export const about_data = [
  // {
  //   date: "06/2026 xx",
  //   color: "#9cba8f",
  //   title:
  //     "Filmmaking Short Course - catalyst (Institute for Creative Arts and Technology)",
  //   description: "➢",
  // },
  // {
  //   date: "summer 2025",
  //   color:
  //     "linear-gradient(to right, rgb(82, 155, 156) 50%, rgb(156, 186, 143) 100%)",
  //   title: "Summer School - Seoul (South Korea) Hanyang University",
  //   description: "➢ 4 weeks program /// ambassador scholarship",
  // },
  // {
  //   date: "XX/2024 - today",
  //   color: "#d27575",
  //   title:
  //     "freelance // selling photographs online - ArtHeroes // video editor",
  //   description: "➢",
  // },
  // {
  //   date: "09/2024 - xx",
  //   color: "#d27575",
  //   title: "Web Developer (React) - XXX Company",
  //   description: "➢",
  // },
  // {
  //   date: "10/2023 - 2025 xx",
  //   color: "#529b9c",
  //   title: "Digital Media M.Sc. - Technische Hochschule Brandenburg",
  //   description:
  //     "➢ Master of Science - 3 focus areas: informatics, media production, media studies /// web/app development, interactive visual worlds, visual stories (film, photography, animation)",
  // },
  {
    date: "Film",
    color: "#e2944f",
    title:
      "Extra on a Film Set",
    description:
      "➢ Role: Capitol citizen in 'The Hunger Games: Sunrise on the Reaping (2026)' \n➢ Role: Astoria Customer in Apple TV Series 'Wild Things'",
  },
  {
    date: "coursera",
    color: "#9cba8f",
    title:
      "Coursera Machine Learning by Andrew Ng",
    description:
      "➢ learn Machine Learning Concepts (Supervised ML, Advanced Algorithms)",
  },
  {
    date: "Kaggle",
    color: "#9cba8f",
    title:
      "Kaggle Learn Certifications",
    description:
      "➢ Machine Learning / Data Science (Pandas, Data Visualization, Matplotlib, Seaborn)",
  },
  {
    date: "Master's degree",
    color: "#529b9c",
    title:
      "Medieninformatik M.Sc. / Media Informatics - Berliner Hochschule für Technik",
    description:
      "➢ Web & Software Development, Generative Art, Data Science, HCI and more\n➢ Master thesis: 'Use of machine learning to predict child mortality rates and identify relevant influencing indicators: A simulation-based country-level analysis.'",
  },
  {
    date: "Web Developer",
    color: "#d27575",
    title: "Web Developer - glow communication GmbH (Berlin)",
    description:
      "➢ Sub-Team Lead: Team's technical advisor and sounding board for complex project challenges\n➢ built interactive websites for various clients, websites maintenance, bug fixings and more (clients incl. Prevent Waste Alliance, Inpacs, Polizei Berlin, NC-Group, Diakonie ...)",
  },
  {
    date: "Photography",
    color: "#9cba8f",
    title: "Photography Certificate - OfG (Online Schule für Gestaltung)",
    description:
      "➢ work with light / product photography / colors and black & white / from street to macro photography / visual storytelling",
  },
  {
    date: "Internship",
    color: "#d27575",
    title: "Internship Web Developer - Deutsche Presse-Agentur (Berlin)",
    description:
      "➢ developed HTML/JS templates for Wordpress addons: imagewall, quiz, timeline, referendum, covid barchart race with d3.js",
  },
  {
    date: "Bachelor's degree",
    color: "#529b9c",
    title:
      "Medieninformatik B.Sc. / Media Informatics - Berliner Hochschule für Technik",
    description:
      "➢ Bachelor of Science - focus on computer science fundamentals & programming / software & web development / interaction & user experience",
  },
  {
    date: "High School",
    color: "#529b9c",
    title: "Abitur / High School Graduation",
    description: "",
  },
];

export const skills_data = [
  {
    languages: ["German", "English", "Arabic", "French", "Korean"],
    programming: [],
    design: [],
  },
];

export const hobbys_data = [
  {
    hobbys: [
      "photography",
      "cinematic filming",
      "web development",
      "fitness/weight training",
      "table tennis",
    ],
  },
];
